import React, { Component } from 'react';
import { fieldPropTypes } from 'redux-form';
import { Checkbox } from 'components/FormFieldsSimple/Checkbox';
import { ReduxFormElementWrapper } from '../_ReduxFormElementWrapper';

export class CheckboxField extends Component {
  static propTypes = {
    ...fieldPropTypes,
  };

  handleChange = (value) => {
    const { input } = this.props;
    input.onFocus();
    input.onChange(value);
    input.onBlur();
  };

  render() {
    const { input, testId } = this.props;

    return (
      <ReduxFormElementWrapper {...this.props} childrenMarginTop="14px">
        <Checkbox
          {...this.props}
          type="checkbox"
          onChange={this.handleChange}
          value={input.value}
          testId={testId}
        />
      </ReduxFormElementWrapper>
    );
  }
}
